<div class="icon-input-container" (click)="onShowPanel($event)">
  <input class="form-control"
         [value]="selectedDraftName"
         [placeholder]="'Select Draft' | translate"
         [ngClass]="isDisabled ? 'disabled': 'enabled'"
         readonly>
  <bringoz-icon iconName="chevron-down" class="input-icon right pointer primary-300"></bringoz-icon>
</div>
